import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Box from "@mui/material/Box";
import { DataGrid, GridToolbarContainer } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import { getFacilities } from "../../app/actions/facilities";

const columns = [
  { headerName: "Facility name", field: "name", width: 250 },
  { headerName: "Address", field: "address", width: 190 },
  { headerName: "City/Town", field: "city", width: 120 },
  { headerName: "State/Prov.", field: "state", width: 120 },
  { headerName: "Country", field: "country", width: 120 },
  { headerName: "Created On", field: "created", width: 160 },
  { headerName: "Last Edited On", field: "updated", width: 160 },
  // {
  //   field: "actions",
  //   type: "actions",
  //   headerName: "Actions",
  //   width: 100,
  //   cellClassName: "actions",
  //   getActions: ({ id }) => {
  //     return [
  //       <GridActionsCellItem
  //         icon={<EditIcon />}
  //         label="Edit"
  //         className="textPrimary"
  //         onClick={handleEditClick(id)}
  //         color="inherit"
  //       />,
  //       <GridActionsCellItem
  //         icon={<DeleteIcon />}
  //         label="Delete"
  //         onClick={handleDeleteClick(id)}
  //         color="inherit"
  //       />,
  //     ];
  //   },
  // },
];

function AddFacility(props) {
  let navigate = useNavigate();

  return (
    <GridToolbarContainer>
      <Button
        color="primary"
        startIcon={<AddIcon />}
        onClick={() => {
          navigate(`/add-facility`);
        }}
      >
        Add New Facility
      </Button>
    </GridToolbarContainer>
  );
}

const MyFacilities = () => {
  const { user: currentUser } = useSelector((state) => state.auth);
  const { myfacilities: facilities } = useSelector((state) => state.facility);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getFacilities());
  }, []);

  let navigate = useNavigate();

  const handleRowClick = (params) => {
    const { id } = params;
    navigate(`/facility/${id}`);
  };

  let content;

  content = (
    <section className="facilities">
      <h1>My Facilities</h1>
      <Box sx={{ width: "100%" }}>
        <DataGrid
          onRowClick={handleRowClick}
          rows={facilities}
          columns={columns}
          slots={{
            toolbar: AddFacility,
          }}
        />
      </Box>
    </section>
  );

  return content;
};
export default MyFacilities;
